import React, { useEffect, useState } from "react";

import Services from "./components/Services";
import AboutCircuitcy from "./components/AboutCircuitcy";
import PlacementHighlight from "./components/PlacementHighlight";
import Contact from "./components/contact";
import HeroCarousel from "./components/Hero";
import Footer from "./components/Footer";
import Background from "./images/bg1.jpg";
import FaqSection from "./components/FaqSection";
import InternshipTimeline from "./components/InternshipTimeline";
import AnimatedSection from "./components/AnimatedSection";
import ResumeSupport from "./components/ResumeSupport";
import Header from "./components/Header";
import GeminiChat from "./components/GeminiChat";
import Loader from "./components/Loader";
import { Helmet } from "react-helmet";
function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0); // force scroll to top on reload

    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500); // splash visible for 1 second

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) return <Loader />;

  return (
    <>
<Helmet>
      <title>Circuitcy Technology Pvt. Ltd.</title>
        <meta name="description" content="Circuitcy offers hands-on internships and training in Mechanical, Electrical, Electronics, and IT engineering to help students gain real-world skills and career readiness." />
        <meta name="keywords" content="Circuitcy, internships, IT training, electronics, engineering, career" />
        <meta name="author" content="Circuitcy Technology Pvt. Ltd." />
      </Helmet>

    <div
      className="text-gray-800 bg-fixed bg-repeat-round scroll-smooth fade-in"
      style={{ backgroundImage: `url(${Background})` }}
    >
      {/* Navbar */}
      <Header />

      {/* Hero */}
      <div className="-mt-16">
       
          <HeroCarousel />
       
      </div>

      {/* About */}
      <section id="about" className="bg-transparent py-6 px-4">
        <AboutCircuitcy />
      </section>

      {/* Services */}
      <section id="services" className="bg-gray-100 mt-2 rounded-md">
        <h2 className="text-3xl md:text-3xl font-bold text-left px-6 pt-12 text-sky-800">
          <span className="text-5xl text-teal-800">|</span> Webinar & Internship We Offer
        </h2>
        <Services />
      </section>

      {/* Timeline */}
      <section id="process" className="bg-white">
        <AnimatedSection>
          <InternshipTimeline />
        </AnimatedSection>
      </section>

      <GeminiChat />

      <AnimatedSection>
        <ResumeSupport />
      </AnimatedSection>

      <AnimatedSection>
        <PlacementHighlight />
      </AnimatedSection>

      {/* Job Opportunities */}
      <section className="bg-white py-16 mt-4 px-6 md:px-12" id="jobs">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
            Future Job Opportunities
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: "Embedded Systems Engineer",
                desc: "Work on real-time control systems, microcontrollers, and IoT devices.",
              },
              {
                title: "Automation Engineer",
                desc: "Design and implement automated systems in manufacturing and robotics.",
              },
              {
                title: "Software Developer (Full Stack)",
                desc: "Build and maintain web-based applications using modern frameworks.",
              },
              {
                title: "PCB Design Engineer",
                desc: "Design printed circuit boards using ECAD tools for product development.",
              },
              {
                title: "Electrical Design Engineer",
                desc: "Design electrical systems for industrial or commercial applications.",
              },
              {
                title: "IT Support / System Admin",
                desc: "Maintain networks, troubleshoot issues, and support enterprise infrastructure.",
              },
            ].map((job, index) => (
              <div
                key={index}
                className="p-6 bg-gray-50 border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition"
              >
                <h3 className="text-xl font-semibold text-sky-600 mb-2">
                  {job.title}
                </h3>
                <p className="text-gray-700">{job.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="bg-transparent py-6 px-4">
        <Contact />
      </section>

      <AnimatedSection>
        <FaqSection />
      </AnimatedSection>

        <Footer />
    
    </div>
    </>
  );
}

export default App;
